module.exports = __webpack_public_path__ + "static/media/undraw_online_shopping_ga73.c8992a3c.png";